/** Common password reset/ welcome code. */
import zxcvbn from 'zxcvbn';
import ConstValues from 'utils/const';

/**
 * Get an estimate of a password's strength.
 *
 * @param password the password.
 */
export function strength(password: string): number | undefined {
  return password ? zxcvbn(password).guesses_log10 : undefined;
}

/**
 * Get the css class name corresponding to the password strength value.
 * @param passwordStrength estimate of password strength.
 * @see strength
 */
export const getStrengthClassName = (passwordStrength: number | undefined): string | undefined => {
  if (passwordStrength) {
    if (passwordStrength > ConstValues.strongPasswordLevel) {
      return 'strong';
    } else if (passwordStrength > ConstValues.mediumPasswordLevel) {
      return 'medium';
    } else {
      return 'weak';
    }
  } else {
    return undefined;
  }
};

/**
 * Is the password strength acceptable?
 * @param passwordStrength the strength.
 */
export const isPasswordStrengthSufficient = (passwordStrength: number | undefined): boolean => {
  return !!passwordStrength && passwordStrength >= ConstValues.mediumPasswordLevel;
};
